import { observable, configure, action } from 'mobx';
import LocalModel from './localModel';

import util from 'preact-util';

configure({ enforceActions: 'always' });

class SignRequestStore extends LocalModel {
    constructor() {
        super('signRequest', {
            namePlural: 'signRequests',
            namePluralReal: 'signrequests',
            sort: '-createdDate',
            limit: 100,
            api: {
                search: { url: '/api/signrequests/', params: { limit: 100, sort: '-createdDate' } },
                load: { url: '/api/signrequests/', params: {} },
                save: { url: '/api/signrequests/', params: {} },
            },
        });
    }

    @observable signRequests = [];

    @observable signRequest = {};

    @action
    clearAll() {
        this.signRequests = [];
        this.signRequest = {};
    }

    async createRequest({ title, message, documents, fileId, fileMd5, signers, expiryDays = 14 }) {
        const response = await util.fetchApi('/api/signrequests/', { method: 'POST' }, {
            title,
            message,
            documents,
            // Keep the singular fields for callers that have not migrated yet.
            fileId,
            fileMd5,
            signers,
            expiryDays,
        });
        if (response && response.data) {
            this.updateKeyValue('signRequest', response.data);
        }
        return response;
    }

    async send(id) {
        return util.fetchApi(`/api/signrequests/${id}/send`, { method: 'POST' }, {});
    }

    async cancel(id) {
        return util.fetchApi(`/api/signrequests/${id}/cancel`, { method: 'POST' }, {});
    }

    async remind(id) {
        return util.fetchApi(`/api/signrequests/${id}/remind`, { method: 'POST' }, {});
    }

    // Retry sealing for a request whose signing is finished but which is not sealed
    // (e.g. an earlier seal attempt failed). Idempotent if already sealed.
    async reseal(id) {
        return util.fetchApi(`/api/signrequests/${id}/reseal`, { method: 'POST' }, {});
    }

    // Email the sealed PDF to everyone who has signed (plus the sender). Only valid
    // once the request is completed and sealed. Repeatable.
    async sendSigned(id) {
        return util.fetchApi(`/api/signrequests/${id}/send-signed`, { method: 'POST' }, {});
    }
}

const store = new SignRequestStore();
export default store;
